import { MinusCircleOutlined, PlusOutlined, LinkOutlined, DisconnectOutlined, MailOutlined, EditOutlined, ToolOutlined, FileAddOutlined, DownloadOutlined } from "@ant-design/icons";
import { message, Row, Col, Spin, PageHeader, Space, Tooltip, Tag, Select } from "antd";
import { ColorPicker } from "antd5";
import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import {
  Form,
  FormItem,
  InputItem,
  InputNumberItem,
  TextAreaItem,
  CheckItem,
  DatePickerItem,
  SelectItem,
  ButtonItem,
  ErrorItem,
} from "../../../../Components/Items";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import GrupoCasillasItem from "../../../../Components/GrupoCasillasItem";
import CasillasExclusivasItem, { OPCIONES_RECOLECCION_ENTREGA } from "../../../../Components/CasillasExclusivasItem";
import LigarCotizacion from "../LigarCotizacion/LigarCotizacion";
import MandarCorreoPreCotizacion from "../MandarCorreoPreCotizacion/MandarCorreoPreCotizacion";
import {
  nuevaClaveRenglon,
  asegurarClaves,
  etiquetaRenglon,
  metrosTotalesPieza,
  totalesPiezas,
  cuadrePorRenglon,
  formatearCantidad as formatearCantidadPieza,
} from "../piezasPreCotizacion";
import { exportarDesglosePiezas } from "../exportarDesglosePiezas";

const { Option } = Select;

if (typeof document !== "undefined") {
  const styleId = "pci-scroll-thin-style";
  if (!document.getElementById(styleId)) {
    const styleEl = document.createElement("style");
    styleEl.id = styleId;
    styleEl.textContent = `
      .pci-scroll-thin {
        scrollbar-width: thin;
        scrollbar-color: #d9d9d9 transparent;
      }
      .pci-scroll-thin::-webkit-scrollbar {
        height: 6px;
      }
      .pci-scroll-thin::-webkit-scrollbar-track {
        background: transparent;
      }
      .pci-scroll-thin::-webkit-scrollbar-thumb {
        background-color: #d9d9d9;
        border-radius: 3px;
      }
      .pci-scroll-thin::-webkit-scrollbar-thumb:hover {
        background-color: #bfbfbf;
      }
    `;
    document.head.appendChild(styleEl);
  }
}

const ESTADOS_ORDEN_MAQUILA = {
  0: { texto: "Cancelada", color: "red" },
  1: { texto: "Abierta", color: "blue" },
  2: { texto: "En proceso", color: "orange" },
  3: { texto: "Terminada", color: "green" },
};

/*
  Modo determinado por location.state:
    - Sin id                  → Agregar
    - { id, modo: "editar" }  → Editar
    - { id, modo: "ver" }     → Ver (solo lectura)
*/
class VistaPreCotizacionIngenieria extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    numero: "",
    cotizacionId: null,
    modalLigarVisible: false,
    modalCorreoVisible: false,
    ordenesDeMaquila: [],
  };

  get modo() {
    return this.props.location?.state?.modo || "agregar";
  }

  get id() {
    return this.props.location?.state?.id || null;
  }

  get cotizacionIdOrigen() {
    return this.props.location?.state?.cotizacionId || null;
  }

  // Serie y folio que se sugirieron al abrir el alta. Si el usuario no los toca no se
  // mandan y el backend toma el consecutivo: asi no choca si otro guardo antes.
  numeroSugerido = null;

  componentDidMount() {
    if (this.id) {
      this.consultarPreCotizacion();
      this.consultarOrdenesDeMaquila();
    } else {
      this.consultarSiguienteNumero();
    }
  }

  consultarSiguienteNumero() {
    axios
      .post(
        "preCotizacionIngenieria/siguienteNumero",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success !== 2) return;
        this.numeroSugerido = { serie: res.data.serie, numero: res.data.numero };
        this.formRef.current?.setFieldsValue(this.numeroSugerido);
      });
  }

  crearCotizacion() {
    this.props.history.push("/panel/agregarCotizacion", { preCotizacionId: this.id });
  }

  // La liga vive solo en OrdenDeMaquila.preCotizacionId: aquí se consulta, no se guarda
  // nada del lado de la pre cotización.
  consultarOrdenesDeMaquila() {
    axios
      .post(
        "ordenesDeMaquila/ordenesDeMaquilaDePreCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId: this.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) this.setState({ ordenesDeMaquila: res.data.data || [] });
      })
      .catch(() => this.setState({ ordenesDeMaquila: [] }));
  }

  generarOrdenDeMaquila() {
    this.props.history.push("/panel/vistaOrdenDeMaquila", { preCotizacionId: this.id });
  }

  verOrdenDeMaquila(ordenDeMaquilaId) {
    this.props.history.push("/panel/vistaOrdenDeMaquila", { id: ordenDeMaquilaId, modo: "ver" });
  }

  consultarPreCotizacion() {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/datosPreCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId: this.id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.status === 404) {
          message.error("No se encontró la pre cotización de ingeniería");
        } else {
          this.setState({
            numero: `${res.data.serie || ""} ${res.data.numero || ""}`.trim(),
            cotizacionId: res.data.cotizacionId || null,
          });
          this.formRef.current.setFieldsValue({
            ...res.data,
            fechaCompromiso: res.data.fechaCompromiso ? moment(res.data.fechaCompromiso) : undefined,
            fechaSolicitud: res.data.fechaSolicitud ? moment(res.data.fechaSolicitud) : undefined,
            // Las pre cotizaciones anteriores al desglose de piezas no traen clave en sus
            // renglones; la reciben aquí y se queda al guardar.
            filasCotizacion: asegurarClaves(res.data.filasCotizacion || []),
          });
        }
      });
  }

  // Al quitar una placa, sus piezas se quedan "sin placa" en lugar de apuntar a una
  // clave que ya no existe. Arreglo nuevo con setFields para que el Form.List se entere.
  quitarRenglonCotizacion(remove, name) {
    const form = this.formRef.current;
    const clave = form.getFieldValue(["filasCotizacion", name, "clave"]);
    remove(name);
    if (!clave) return;
    const piezas = form.getFieldValue("piezas") || [];
    if (!piezas.some((pieza) => pieza?.renglonClave === clave)) return;
    form.setFields([
      {
        name: "piezas",
        value: piezas.map((pieza) => (pieza?.renglonClave === clave ? { ...pieza, renglonClave: null } : pieza)),
      },
    ]);
  }

  // Si la pieza todavía no tiene nombre de proyecto, toma el de su placa.
  alElegirPlacaDePieza(name, clave) {
    const form = this.formRef.current;
    if ((form.getFieldValue(["piezas", name, "nombreProyecto"]) || "").trim()) return;
    const fila = (form.getFieldValue("filasCotizacion") || []).find((renglon) => renglon?.clave === clave);
    if (fila?.nombreProyecto) {
      form.setFields([{ name: ["piezas", name, "nombreProyecto"], value: fila.nombreProyecto }]);
    }
  }

  // Sale de lo que está en pantalla, así sirve aunque todavía no se haya guardado.
  descargarExcelPiezas() {
    const form = this.formRef.current;
    const piezas = form.getFieldValue("piezas") || [];
    if (piezas.length === 0) {
      message.info("No hay piezas en el desglose");
      return;
    }
    try {
      exportarDesglosePiezas({
        piezas,
        filasCotizacion: form.getFieldValue("filasCotizacion") || [],
        serie: form.getFieldValue("serie"),
        numero: form.getFieldValue("numero"),
        nombreProyecto: form.getFieldValue("nombreProyecto"),
        empresaNombre: this.props.empresaNombre,
      });
    } catch (error) {
      console.error(error);
      message.error("No se pudo generar el Excel del desglose");
    }
  }

  atras() {
    this.props.history.goBack();
  }

  editar() {
    this.props.history.replace("/panel/vistaPreCotizacionIngenieria", { id: this.id, modo: "editar" });
  }

  verCotizacion() {
    this.props.history.push("/panel/verCotizacion", { id: this.state.cotizacionId });
  }

  abrirLigar() {
    this.setState({ modalLigarVisible: true });
  }

  cerrarLigar(seLigo) {
    this.setState({ modalLigarVisible: false });
    if (seLigo) this.consultarPreCotizacion();
  }

  desligar() {
    this.setState({ loading: true });
    axios
      .post(
        "preCotizacionIngenieria/desligarCotizacion",
        { empresaId: this.props.empresaId, preCotizacionId: this.id, cotizacionId: this.state.cotizacionId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se desligó la cotización");
          this.consultarPreCotizacion();
        } else {
          message.error("No se pudo desligar la cotización");
        }
      });
  }

  abrirCorreo() {
    this.setState({ modalCorreoVisible: true });
  }

  cerrarCorreo() {
    this.setState({ modalCorreoVisible: false });
  }

  normColor(color) {
    if (!color) return null;
    if (typeof color === "string") return color;
    if (typeof color.toHexString === "function") return color.toHexString();
    return null;
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  onFinish(values) {
    this.setState({ loading: true });
    const esEditar = this.modo === "editar";

    const { serie, numero, ...resto } = values;
    const sinCambiarFolio =
      !esEditar &&
      this.numeroSugerido &&
      (serie || "").trim() === this.numeroSugerido.serie &&
      numero === this.numeroSugerido.numero;

    axios
      .post(
        esEditar ? "preCotizacionIngenieria/editarPreCotizacion" : "preCotizacionIngenieria/agregarPreCotizacion",
        {
          ...resto,
          ...(sinCambiarFolio ? {} : { serie, numero }),
          empresaId: this.props.empresaId,
          ...(esEditar
            ? { preCotizacionId: this.id }
            : { cotizacionId: this.cotizacionIdOrigen || undefined }),
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            esEditar
              ? "Se ha editado la pre cotización de ingeniería"
              : "Se ha registrado la pre cotización de ingeniería"
          );
          if (esEditar) {
            this.atras();
          } else if (this.cotizacionIdOrigen) {
            this.props.history.push("/panel/verCotizacion", { id: this.cotizacionIdOrigen });
          } else {
            this.props.history.push("/panel/preCotizacionIngenieria");
          }
        } else if (res.data.success === 1) {
          message.error(res.data.message || "No se pudo guardar la pre cotización");
        } else {
          message.error("Hubo un error y la pre cotización no se guardó");
        }
      });
  }

  render() {
    const modo = this.modo;
    const soloLectura = modo === "ver";

    const titulos = {
      agregar: "Agregar Pre Cotización",
      editar: "Editar Pre Cotización",
      ver: `Ver Pre Cotización${this.state.numero ? ` ( ${this.state.numero} )` : ""}`,
    };

    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title={titulos[modo] || "Pre Cotización"}
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            soloLectura ? (
              <Space>
                {this.state.cotizacionId ? (
                  <>
                    <ButtonItem type="default" lila icon={<LinkOutlined />} onClick={this.verCotizacion.bind(this)}>
                      Ver Cotización
                    </ButtonItem>
                    <ButtonItem type="default" danger icon={<DisconnectOutlined />} onClick={this.desligar.bind(this)}>
                      Desligar
                    </ButtonItem>
                  </>
                ) : (
                  <>
                    {this.props.permisoAgregarCotizaciones && (
                      <ButtonItem
                        type="default"
                        lila
                        icon={<FileAddOutlined />}
                        onClick={this.crearCotizacion.bind(this)}
                      >
                        Crear Cotización
                      </ButtonItem>
                    )}
                    <ButtonItem type="default" cyan icon={<LinkOutlined />} onClick={this.abrirLigar.bind(this)}>
                      Ligar Cotización
                    </ButtonItem>
                  </>
                )}
                <ButtonItem
                  type="default"
                  olivo
                  icon={<ToolOutlined />}
                  onClick={this.generarOrdenDeMaquila.bind(this)}
                >
                  Generar Orden de Maquila
                </ButtonItem>
                <ButtonItem type="default" gris icon={<MailOutlined />} onClick={this.abrirCorreo.bind(this)}>
                  Mandar Correo
                </ButtonItem>
                <ButtonItem type="primary" lima onClick={this.editar.bind(this)} icon={<EditOutlined />}>
                  Editar
                </ButtonItem>
              </Space>
            ) : null
          }
        />
        {/* Fuera del <Form> a proposito: editarPreCotizacion hace un $set masivo del body
            y cualquier campo registrado aqui terminaria escribiendose en la pre cotizacion. */}
        {soloLectura && this.state.ordenesDeMaquila.length > 0 && (
          <Row gutter={16}>
            <DynamicCardForm title="Órdenes de maquila generadas" xs={24}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 12, alignItems: "center" }}>
                {this.state.ordenesDeMaquila.map((orden) => {
                  const etiqueta = ESTADOS_ORDEN_MAQUILA[orden.estado] || { texto: "—", color: "default" };
                  return (
                    <div key={orden._id} style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <ButtonItem
                        type="default"
                        size="small"
                        blanco
                        icon={<ToolOutlined />}
                        onClick={() => this.verOrdenDeMaquila(orden._id)}
                      >
                        {orden.folio}
                      </ButtonItem>
                      <Tag color={etiqueta.color}>{etiqueta.texto}</Tag>
                    </div>
                  );
                })}
              </div>
            </DynamicCardForm>
          </Row>
        )}
        <Spin spinning={this.state.loading}>
          {/* layoutForm="vertical", igual que en Orden de Maquila: la etiqueta va arriba
              del campo y ninguna se trunca dentro de las tarjetas. */}
          <Form
            ref={this.formRef}
            name="VistaPreCotizacionIngenieria"
            layoutForm="vertical"
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <Row gutter={16}>
              <DynamicCardForm title="Proyecto" xs={24} lg={12} xl={12}>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormItem label="Serie" name="serie" required={!soloLectura} margin>
                      <InputItem placeholder="OI" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={12}>
                    <FormItem
                      label="Folio"
                      name="numero"
                      required={!soloLectura}
                      tooltip={{ title: "Se sugiere el siguiente consecutivo; se puede cambiar si no está ocupado." }}
                      margin
                    >
                      <InputNumberItem placeholder="1" min={1} precision={0} style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24}>
                    <FormItem label="Nombre del proyecto" name="nombreProyecto" required={!soloLectura} margin>
                      <InputItem placeholder="Nombre del proyecto" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem label="Encargado" name="encargadoProyecto" margin>
                      <InputItem placeholder="Quién lo lleva" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Orden de maquila"
                      name="ordenMaquila"
                      tooltip={{
                        title:
                          "Referencia escrita a mano. Las órdenes de maquila del sistema se generan con el botón de arriba.",
                      }}
                      margin
                    >
                      <InputItem placeholder="Referencia" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <GrupoCasillasItem label="Prioridad">
                  <FormItem name="urgente" valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>Urgente</CheckItem>
                  </FormItem>
                </GrupoCasillasItem>
              </DynamicCardForm>

              <DynamicCardForm title="Cliente y fechas" xs={24} lg={12} xl={12}>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem label="Cliente" name="cliente" margin>
                      <InputItem placeholder="Cliente" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem label="Contacto" name="contacto" margin>
                      <InputItem placeholder="Con quién se ve" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <Row gutter={16}>
                  <Col xs={12}>
                    <FormItem label="Solicitud" name="fechaSolicitud" margin>
                      <DatePickerItem placeholder="Solicitud" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={12}>
                    <FormItem label="Compromiso" name="fechaCompromiso" margin>
                      <DatePickerItem placeholder="Compromiso" style={{ width: "100%" }} disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <GrupoCasillasItem label="Programación de entrega">
                  <FormItem name="recoleccionOEntrega" noStyle>
                    <CasillasExclusivasItem opciones={OPCIONES_RECOLECCION_ENTREGA} disabled={soloLectura} />
                  </FormItem>
                </GrupoCasillasItem>
              </DynamicCardForm>

              {/* "DATOS DEL MATERIAL SOLICITADO" del formato de papel. Proveedor del material
                  se quedó fuera (2026-10-19) y no está en el papel. */}
              <DynamicCardForm title="Datos del material solicitado" xs={24}>
                <GrupoCasillasItem label="Suministra">
                  <FormItem name="materialPropio" valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>La empresa</CheckItem>
                  </FormItem>
                  <FormItem name="materialPorCliente" valuePropName="checked" noStyle>
                    <CheckItem disabled={soloLectura}>El cliente</CheckItem>
                  </FormItem>
                </GrupoCasillasItem>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Procesos"
                      name="procesos"
                      tooltip={{ title: "Se copian a los procesos de cada material de la orden de maquila." }}
                      margin
                    >
                      <TextAreaItem
                        placeholder="Corte láser, doblez y digitalización"
                        rows={2}
                        disabled={soloLectura}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem label="Características del material" name="caracteristicasGenerales" margin>
                      <InputItem placeholder="A36, CAL.10" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
                <FormItem label="Materiales solicitados" margin>
                  <Form.List name="caracteristicasMaterial">
                    {(fields, { add, remove }) => (
                      <>
                        {soloLectura && fields.length === 0 && (
                          <div style={{ color: "#999" }}>Sin materiales solicitados</div>
                        )}
                        {fields.map(({ key, name, ...restField }, posicion) => (
                          <Row key={key} gutter={8} align="middle" wrap={false}>
                            {/* El número va fuera del FormItem: el campo es su hijo directo. */}
                            <Col flex="28px" style={{ color: "#8c8c8c", textAlign: "right" }}>
                              {posicion + 1}
                            </Col>
                            <Col flex="auto">
                              <FormItem {...restField} name={[name, "descripcion"]} margin>
                                <InputItem placeholder="1 PLACA A36, CAL.10 x 4 x 10FT" disabled={soloLectura} />
                              </FormItem>
                            </Col>
                            {!soloLectura && (
                              <Col flex="28px">
                                <MinusCircleOutlined
                                  style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                  onClick={() => remove(name)}
                                />
                              </Col>
                            )}
                          </Row>
                        ))}
                        {!soloLectura && (
                          <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Agregar material solicitado
                          </ButtonItem>
                        )}
                      </>
                    )}
                  </Form.List>
                </FormItem>
              </DynamicCardForm>

              <DynamicCardForm title="Cotización previa por ingeniería" xs={24}>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Etiqueta de la columna extra 1"
                      name="columnaExtra1Label"
                      initialValue="BAJADAS (CIZALLA)"
                      margin
                    >
                      <InputItem placeholder="BAJADAS (CIZALLA)" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Etiqueta de la columna extra 2"
                      name="columnaExtra2Label"
                      initialValue="DOBLECES"
                      margin
                    >
                      <InputItem placeholder="DOBLECES" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>

                <ContenedorTabla minWidth={1100}>
                  <FormItem
                    noStyle
                    shouldUpdate={(anterior, actual) =>
                      anterior?.columnaExtra1Label !== actual?.columnaExtra1Label ||
                      anterior?.columnaExtra2Label !== actual?.columnaExtra2Label
                    }
                  >
                    {({ getFieldValue }) => (
                      <TablaGridHeader
                        soloLectura={soloLectura}
                        template={FILAS_COTIZACION_TEMPLATE(soloLectura)}
                        columnas={[
                          "Color",
                          "Material",
                          "Calibre",
                          "Dimensiones",
                          "Nombre de proyecto",
                          "Piezas totales",
                          "Material requerido",
                          "Metros de corte",
                          getFieldValue("columnaExtra1Label") || "Extra 1",
                          getFieldValue("columnaExtra2Label") || "Extra 2",
                          "Notas",
                        ]}
                      />
                    )}
                  </FormItem>
                  <Form.List name="filasCotizacion">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.length === 0 && (
                          <div style={{ color: "#999", padding: "10px 12px" }}>
                            {soloLectura ? "Sin renglones" : "Todavía no hay renglones."}
                          </div>
                        )}
                        {fields.map(({ key, name, ...restField }) => (
                          // shouldUpdate acotado al material de este renglón y del anterior:
                          // el color solo se edita en el primero de cada material. Calibre y
                          // dimensiones son de cada pieza y se capturan en todos los renglones.
                          <FormItem
                            key={key}
                            noStyle
                            shouldUpdate={(anterior, actual) =>
                              anterior?.filasCotizacion?.[name]?.grupo !== actual?.filasCotizacion?.[name]?.grupo ||
                              anterior?.filasCotizacion?.[name - 1]?.grupo !==
                                actual?.filasCotizacion?.[name - 1]?.grupo
                            }
                          >
                            {({ getFieldValue }) => {
                              const primeroDeGrupo = esPrimeroDeGrupo(getFieldValue("filasCotizacion") || [], name);
                              return (
                                <div style={filaTablaStyle(FILAS_COTIZACION_TEMPLATE(soloLectura), name)}>
                                  <Tooltip
                                    title={
                                      primeroDeGrupo
                                        ? "Color de este material"
                                        : "El color se define en el primer renglón de este material"
                                    }
                                  >
                                    <FormItem
                                      {...restField}
                                      name={[name, "colorGrupo"]}
                                      getValueFromEvent={this.normColor}
                                      noStyle
                                    >
                                      <ColorPicker
                                        disabledAlpha
                                        format="hex"
                                        size="small"
                                        disabled={soloLectura || !primeroDeGrupo}
                                      />
                                    </FormItem>
                                  </Tooltip>
                                  <FormItem {...restField} name={[name, "grupo"]} noStyle>
                                    <InputItem placeholder="LÁMINA NEGRA" disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "calibre"]} noStyle>
                                    <InputItem placeholder="Cal. 14" disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "dimensiones"]} noStyle>
                                    <InputItem placeholder="1220 x 2440" disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "nombreProyecto"]} noStyle>
                                    <InputItem placeholder="Nombre de proyecto" disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "piezasTotales"]} noStyle>
                                    <InputNumberItem placeholder="0" style={{ width: "100%" }} disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "materialRequerido"]} noStyle>
                                    <InputItem placeholder="Material requerido" disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "metrosCorte"]} noStyle>
                                    <InputNumberItem placeholder="0" style={{ width: "100%" }} disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "valorExtra1"]} noStyle>
                                    <InputNumberItem placeholder="0" style={{ width: "100%" }} disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "valorExtra2"]} noStyle>
                                    <InputNumberItem placeholder="0" style={{ width: "100%" }} disabled={soloLectura} />
                                  </FormItem>
                                  <FormItem {...restField} name={[name, "notas"]} noStyle>
                                    <InputItem placeholder="Notas" disabled={soloLectura} />
                                  </FormItem>
                                  {!soloLectura && (
                                    <div style={{ textAlign: "center" }}>
                                      <MinusCircleOutlined
                                        style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                        onClick={() => this.quitarRenglonCotizacion(remove, name)}
                                      />
                                    </div>
                                  )}
                                </div>
                              );
                            }}
                          </FormItem>
                        ))}
                        {fields.length > 0 && (
                          // Se repinta con cualquier tecla de la tabla, pero es solo este
                          // renglón: los de captura siguen acotados a su material.
                          <FormItem
                            noStyle
                            shouldUpdate={(anterior, actual) => anterior?.filasCotizacion !== actual?.filasCotizacion}
                          >
                            {({ getFieldValue }) => (
                              <FilaTotales filas={getFieldValue("filasCotizacion") || []} soloLectura={soloLectura} />
                            )}
                          </FormItem>
                        )}
                        {!soloLectura && (
                          // La clave liga las piezas del desglose con este renglón.
                          <ButtonItem
                            type="dashed"
                            onClick={() => add({ clave: nuevaClaveRenglon() })}
                            block
                            icon={<PlusOutlined />}
                          >
                            Agregar renglón
                          </ButtonItem>
                        )}
                      </>
                    )}
                  </Form.List>
                </ContenedorTabla>

                <Row gutter={16} style={{ marginTop: 12 }}>
                  <Col xs={24} md={12}>
                    <FormItem label="Tiempo de soldadura" name="tiempoSoldadura" margin>
                      <InputItem placeholder="6Hrs 15Min" disabled={soloLectura} />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>

              {/* Qué piezas van en cada placa de la cotización previa. Cada pieza apunta a su
                  placa por la clave del renglón (no por índice). */}
              <DynamicCardForm
                title="Desglose de piezas"
                xs={24}
                headerRight={
                  <FormItem
                    noStyle
                    shouldUpdate={(anterior, actual) =>
                      (anterior?.piezas?.length || 0) !== (actual?.piezas?.length || 0)
                    }
                  >
                    {({ getFieldValue }) => (
                      <ButtonItem
                        type="default"
                        size="small"
                        blanco
                        icon={<DownloadOutlined />}
                        disabled={(getFieldValue("piezas") || []).length === 0}
                        onClick={this.descargarExcelPiezas.bind(this)}
                      >
                        Descargar Excel
                      </ButtonItem>
                    )}
                  </FormItem>
                }
              >
                <ContenedorTabla minWidth={900}>
                  <TablaGridHeader
                    soloLectura={soloLectura}
                    template={PIEZAS_TEMPLATE(soloLectura)}
                    columnas={[
                      "Nombre del proyecto",
                      "Número de parte",
                      "Material (placa)",
                      "Metros por pieza",
                      "Cantidad de piezas",
                      "Metros totales",
                    ]}
                  />
                  <Form.List name="piezas">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.length === 0 && (
                          <div style={{ color: "#999", padding: "10px 12px" }}>
                            {soloLectura ? "Sin piezas" : "Todavía no hay piezas."}
                          </div>
                        )}
                        {fields.map(({ key, name, ...restField }) => (
                          <div key={key} style={filaTablaStyle(PIEZAS_TEMPLATE(soloLectura), name)}>
                            <FormItem {...restField} name={[name, "nombreProyecto"]} noStyle>
                              <InputItem placeholder="Nombre del proyecto" disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "numeroParte"]} noStyle>
                              <InputItem placeholder="No. de parte" disabled={soloLectura} />
                            </FormItem>
                            {/* Las opciones siguen a los renglones de arriba: si se edita o
                                agrega una placa, el select lo refleja. */}
                            <FormItem
                              noStyle
                              shouldUpdate={(anterior, actual) => anterior?.filasCotizacion !== actual?.filasCotizacion}
                            >
                              {({ getFieldValue }) => (
                                <FormItem {...restField} name={[name, "renglonClave"]} noStyle>
                                  <SelectItem
                                    placeholder="Placa"
                                    allowClear
                                    style={{ width: "100%" }}
                                    disabled={soloLectura}
                                    onChange={(clave) => this.alElegirPlacaDePieza(name, clave)}
                                  >
                                    {(getFieldValue("filasCotizacion") || []).map((fila, indice) =>
                                      fila?.clave ? (
                                        <Option key={fila.clave} value={fila.clave}>
                                          {etiquetaRenglon(fila, indice)}
                                        </Option>
                                      ) : null
                                    )}
                                  </SelectItem>
                                </FormItem>
                              )}
                            </FormItem>
                            <FormItem {...restField} name={[name, "metrosPorPieza"]} noStyle>
                              <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "cantidad"]} noStyle>
                              <InputNumberItem placeholder="0" min={0} style={{ width: "100%" }} disabled={soloLectura} />
                            </FormItem>
                            <FormItem
                              noStyle
                              shouldUpdate={(anterior, actual) =>
                                anterior?.piezas?.[name]?.metrosPorPieza !== actual?.piezas?.[name]?.metrosPorPieza ||
                                anterior?.piezas?.[name]?.cantidad !== actual?.piezas?.[name]?.cantidad
                              }
                            >
                              {({ getFieldValue }) => (
                                <span style={{ textAlign: "right", paddingRight: 11, color: "#595959" }}>
                                  {formatearCantidadPieza(metrosTotalesPieza(getFieldValue(["piezas", name]) || {}))}
                                </span>
                              )}
                            </FormItem>
                            {!soloLectura && (
                              <div style={{ textAlign: "center" }}>
                                <MinusCircleOutlined
                                  style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                  onClick={() => remove(name)}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                        {fields.length > 0 && (
                          <FormItem
                            noStyle
                            shouldUpdate={(anterior, actual) => anterior?.piezas !== actual?.piezas}
                          >
                            {({ getFieldValue }) => (
                              <FilaTotalesPiezas piezas={getFieldValue("piezas") || []} soloLectura={soloLectura} />
                            )}
                          </FormItem>
                        )}
                        {!soloLectura && (
                          <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Agregar pieza
                          </ButtonItem>
                        )}
                      </>
                    )}
                  </Form.List>
                </ContenedorTabla>

                <FormItem
                  noStyle
                  shouldUpdate={(anterior, actual) =>
                    anterior?.piezas !== actual?.piezas || anterior?.filasCotizacion !== actual?.filasCotizacion
                  }
                >
                  {({ getFieldValue }) => (
                    <CuadrePorPlaca
                      filas={getFieldValue("filasCotizacion") || []}
                      piezas={getFieldValue("piezas") || []}
                    />
                  )}
                </FormItem>
              </DynamicCardForm>

              <DynamicCardForm title="Extras (tornillería)" xs={24}>
                <ContenedorTabla minWidth={700}>
                  <TablaGridHeader
                    soloLectura={soloLectura}
                    template={EXTRAS_TEMPLATE(soloLectura)}
                    columnas={["Tipo", "Medida", "Largo", "Total de piezas", "Notas"]}
                  />
                  <Form.List name="extras">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.length === 0 && (
                          <div style={{ color: "#999", padding: "10px 12px" }}>
                            {soloLectura ? "Sin extras" : "Todavía no hay extras."}
                          </div>
                        )}
                        {fields.map(({ key, name, ...restField }) => (
                          <div key={key} style={filaTablaStyle(EXTRAS_TEMPLATE(soloLectura), name)}>
                            <FormItem {...restField} name={[name, "tipo"]} noStyle>
                              <InputItem placeholder="Tipo" disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "medida"]} noStyle>
                              <InputItem placeholder="Medida" disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "largo"]} noStyle>
                              <InputItem placeholder="Largo" disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "totalPiezas"]} noStyle>
                              <InputNumberItem placeholder="0" style={{ width: "100%" }} disabled={soloLectura} />
                            </FormItem>
                            <FormItem {...restField} name={[name, "notas"]} noStyle>
                              <InputItem placeholder="Notas" disabled={soloLectura} />
                            </FormItem>
                            {!soloLectura && (
                              <div style={{ textAlign: "center" }}>
                                <MinusCircleOutlined
                                  style={{ fontSize: 16, color: "#ff4d4f", cursor: "pointer" }}
                                  onClick={() => remove(name)}
                                />
                              </div>
                            )}
                          </div>
                        ))}
                        {!soloLectura && (
                          <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                            Agregar extra
                          </ButtonItem>
                        )}
                      </>
                    )}
                  </Form.List>
                </ContenedorTabla>
              </DynamicCardForm>

              <DynamicCardForm title="Notas finales" xs={24}>
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Para la orden de maquila"
                      name="notas"
                      tooltip={{ title: "Se copian a las notas de la orden de maquila que se genere desde aquí." }}
                      margin
                    >
                      <TextAreaItem
                        placeholder="Lo que el piso tiene que saber"
                        rows={3}
                        disabled={soloLectura}
                      />
                    </FormItem>
                  </Col>
                  <Col xs={24} md={12}>
                    <FormItem
                      label="Para la cotización"
                      name="notasCotizacion"
                      tooltip={{
                        title:
                          "Se copian a las Observaciones (las que se imprimen) de la cotización que se cree con \"Crear Cotización\". No pasan a la orden de maquila.",
                      }}
                      margin
                    >
                      <TextAreaItem
                        placeholder="Lo que la cotización al cliente debe decir"
                        rows={3}
                        disabled={soloLectura}
                      />
                    </FormItem>
                  </Col>
                </Row>
              </DynamicCardForm>
            </Row>

            {!soloLectura && (
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10,
                  justifyContent: "flex-end",
                  padding: "14px 16px",
                  background: "white",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
                }}
              >
                <ButtonItem type="default" danger onClick={this.atras.bind(this)}>
                  Cancelar
                </ButtonItem>
                <ButtonItem type="primary" htmlType="submit">
                  {modo === "editar" ? "Guardar cambios" : "Crear pre cotización"}
                </ButtonItem>
              </div>
            )}
          </Form>
        </Spin>
        <LigarCotizacion
          visible={this.state.modalLigarVisible}
          preCotizacionId={this.id}
          onCerrar={this.cerrarLigar.bind(this)}
        />
        <MandarCorreoPreCotizacion
          visible={this.state.modalCorreoVisible}
          id={this.id}
          onCerrar={this.cerrarCorreo.bind(this)}
        />
      </>
    );
  }
}

const esPrimeroDeGrupo = (filas, idx) => {
  if (idx === 0) return true;
  const actual = (filas[idx]?.grupo || "").trim().toUpperCase();
  const anterior = (filas[idx - 1]?.grupo || "").trim().toUpperCase();
  return actual !== anterior;
};

// Color, Material, Calibre, Dimensiones, Nombre, Piezas, Material requerido, Metros,
// Extra 1, Extra 2, Notas (y el botón de quitar al capturar).
const FILAS_COTIZACION_TEMPLATE = (soloLectura) =>
  soloLectura
    ? "4% 11% 7% 9% 12% 6% 11% 7% 8% 8% 17%"
    : "4% 10% 7% 8% 11% 6% 10% 7% 7% 7% 19% 4%";

// 0.1 + 0.2 no debe verse como 0.30000000000000004 (mismo criterio que las notas de la OM).
const formatearCantidad = (valor) => String(Math.round((Number(valor) || 0) * 100) / 100);

const sumarColumna = (filas, campo) =>
  formatearCantidad(filas.reduce((acc, fila) => acc + (Number(fila?.[campo]) || 0), 0));

// Renglón de totales con la misma rejilla que los renglones: "Totales" cubre Color,
// Material, Calibre, Dimensiones y Nombre; luego Piezas, (Material requerido), Metros,
// Extra 1, Extra 2, (Notas) y la columna del botón de quitar al capturar.
const FilaTotales = ({ filas, soloLectura }) => {
  const numeroStyle = { textAlign: "right", paddingRight: 11 };
  return (
    <div
      style={{
        ...filaTablaStyle(FILAS_COTIZACION_TEMPLATE(soloLectura), 0),
        background: "#fafafa",
        borderTop: "1px solid #e8e8e8",
        fontSize: 13,
        fontWeight: 600,
        color: "#595959",
      }}
    >
      <span style={{ gridColumn: "1 / span 5" }}>Totales</span>
      <span style={numeroStyle}>{sumarColumna(filas, "piezasTotales")}</span>
      <span />
      <span style={numeroStyle}>{sumarColumna(filas, "metrosCorte")} m</span>
      <span style={numeroStyle}>{sumarColumna(filas, "valorExtra1")}</span>
      <span style={numeroStyle}>{sumarColumna(filas, "valorExtra2")}</span>
      <span />
      {!soloLectura && <span />}
    </div>
  );
};

const EXTRAS_TEMPLATE = (soloLectura) =>
  soloLectura ? "19% 15% 15% 15% 36%" : "18% 14% 14% 14% 32% 8%";

// Nombre del proyecto, No. de parte, Material (placa), Metros por pieza, Cantidad,
// Metros totales (y el botón de quitar al capturar).
const PIEZAS_TEMPLATE = (soloLectura) =>
  soloLectura ? "21% 15% 31% 11% 11% 11%" : "20% 14% 29% 11% 11% 11% 4%";

// Totales del desglose con la misma rejilla: "Totales" cubre las cuatro primeras columnas.
const FilaTotalesPiezas = ({ piezas, soloLectura }) => {
  const totales = totalesPiezas(piezas);
  const numeroStyle = { textAlign: "right", paddingRight: 11 };
  return (
    <div
      style={{
        ...filaTablaStyle(PIEZAS_TEMPLATE(soloLectura), 0),
        background: "#fafafa",
        borderTop: "1px solid #e8e8e8",
        fontSize: 13,
        fontWeight: 600,
        color: "#595959",
      }}
    >
      <span style={{ gridColumn: "1 / span 4" }}>Totales</span>
      <span style={numeroStyle}>{formatearCantidadPieza(totales.cantidad)}</span>
      <span style={numeroStyle}>{formatearCantidadPieza(totales.metros)} m</span>
      {!soloLectura && <span />}
    </div>
  );
};

// Lo capturado en cada placa contra la suma de sus piezas. Solo avisa: no corrige nada.
const CuadrePorPlaca = ({ filas, piezas }) => {
  const cuadres = cuadrePorRenglon(filas, piezas);
  if (cuadres.length === 0) return null;
  return (
    <div style={{ marginTop: 12 }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: "#595959", marginBottom: 6 }}>Cuadre por placa</div>
      {cuadres.map((cuadre) => (
        <div
          key={cuadre.clave}
          style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "4px 10px", padding: "3px 0" }}
        >
          <Tag color={cuadre.cuadra ? "green" : "orange"} style={{ marginRight: 0 }}>
            {cuadre.cuadra ? "Cuadra" : "No cuadra"}
          </Tag>
          <span>{cuadre.etiqueta}</span>
          <span style={{ color: "#8c8c8c" }}>
            Piezas {formatearCantidadPieza(cuadre.piezasDesglose)} de {formatearCantidadPieza(cuadre.piezasCapturadas)}
            {" · "}
            Metros {formatearCantidadPieza(cuadre.metrosDesglose)} de {formatearCantidadPieza(cuadre.metrosCapturados)}
          </span>
        </div>
      ))}
    </div>
  );
};

const ContenedorTabla = ({ children, minWidth }) => (
  <div
    className="pci-scroll-thin"
    style={{ overflowX: "auto", border: "1px solid #f0f0f0", borderRadius: 8 }}
  >
    <div style={{ minWidth }}>{children}</div>
  </div>
);

const TablaGridHeader = ({ columnas, template, soloLectura }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: template,
      gap: 6,
      padding: "8px 10px",
      background: "#fafafa",
      borderBottom: "1px solid #e8e8e8",
    }}
  >
    {columnas.map((texto) => (
      <span key={texto} style={{ fontSize: 12, fontWeight: 600, color: "#595959" }}>
        {texto}
      </span>
    ))}
    {!soloLectura && <span />}
  </div>
);

// Cebra: con nueve columnas de inputs seguidos, el renglon se pierde sin ella.
const filaTablaStyle = (template, indice) => ({
  display: "grid",
  gridTemplateColumns: template,
  gap: 6,
  alignItems: "center",
  padding: "5px 10px",
  borderBottom: "1px solid #f5f5f5",
  background: indice % 2 === 1 ? "#fcfcfc" : "white",
});

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  empresaNombre: state.empresa.nombre,
  permisoAgregarCotizaciones:
    state.user.tipo === 0 ||
    state.user.permisos.find((valueTodos) => valueTodos.permisoId.toString() === "6750922d798d4e0043687242")
      ?.activado,
});

export default connect(mapStateToProps)(VistaPreCotizacionIngenieria);
